/**
 * FullTaskViewer
 *
 * Full-screen task detail viewer that takes over the entire modal.
 * Includes a back button to return to the main review view.
 */
import { ArrowLeft } from 'lucide-react';

import { TaskDetail } from '@/components/tasks/task-detail/TaskDetail';
import { Button } from '@/components/ui/button';

interface FullTaskViewerProps {
  taskId: string;
  onBack: () => void;
}

export const FullTaskViewer = ({ taskId, onBack }: FullTaskViewerProps) => {
  return (
    <div className="flex h-full flex-col bg-white dark:bg-zinc-900">
      {/* Back button header */}
      <div className="flex-shrink-0 border-b border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 px-4 py-3">
        <Button
          variant="ghost"
          size="sm"
          onClick={onBack}
          className="h-8 gap-1.5 px-2 text-sm font-medium text-zinc-700 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-800"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Back to Review
        </Button>
      </div>

      {/* Task detail viewer */}
      <div className="flex-1 overflow-hidden">
        <TaskDetail taskId={taskId} onClose={onBack} isModal={false} />
      </div>
    </div>
  );
};
